import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, Globe, Flame } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="grid place-items-center w-9 h-9 rounded-xl bg-[#004BCA] text-white"><Flame size={18} /></span>
            <span className="font-display font-bold text-xl">Style<span className="text-[#FF4500]">fire</span></span>
          </div>
          <p className="text-sm text-slate-600">Where Style Meets Fire. Premium women's fashion and footwear, made for India.</p>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3">Shop</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/products?category=Dresses">Dresses</Link></li>
            <li><Link to="/products?category=Tops">Tops</Link></li>
            <li><Link to="/products?category=Footwear">Footwear</Link></li>
            <li><Link to="/products?category=Ethnic">Ethnic</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3">Company</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link data-testid="footer-about" to="/about">About Us</Link></li>
            <li><Link data-testid="footer-help" to="/help">Help & Support</Link></li>
            <li><Link to="/products">All Products</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3">Get in Touch</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li className="flex items-center gap-2"><Phone size={14}/> 9030583449</li>
            <li className="flex items-center gap-2"><Mail size={14}/> stylefire.in@gmail.com</li>
            <li className="flex items-center gap-2"><Instagram size={14}/> stylefire.in</li>
            <li className="flex items-center gap-2"><Globe size={14}/> stylefire.in</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 py-4 text-center text-xs text-slate-500">© {new Date().getFullYear()} Stylefire. All rights reserved.</div>
    </footer>
  );
}
